import axios from './BaseService';

const ANALYTICS_URL = `${process.env.REACT_APP_API_URL}/analytics`;

// Performance summary across all trading engines.
//   mode: 'ALL' | 'PAPER' | 'LIVE'
// Returns:
//   { overall:{realizedPnl,wins,losses,trades,winRate,avgWin,avgLoss,activeBots},
//     byEngine:{today:{...}, risk:{...}, futures:{...}},
//     equityCurve:[{date,pnl,cumulative}] }
export async function getPerformance(mode = 'ALL') {
    const response = await axios.get(`${ANALYTICS_URL}/performance?mode=${encodeURIComponent(mode)}`);
    return response.data;
}
